import { render, staticRenderFns } from "./payDomain.vue?vue&type=template&id=3aa5f232&scoped=true&"
import script from "./payDomain.vue?vue&type=script&lang=js&"
export * from "./payDomain.vue?vue&type=script&lang=js&"
import style0 from "./payDomain.vue?vue&type=style&index=0&id=3aa5f232&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa5f232",
  null
  
)

export default component.exports